export default "__VITE_ASSET__jIDXpLwi__"